import React from 'react';
import './App.css';
import LandingPage from './component/LandingPage';
import wp from "./Images/whatsapplogo.png"
import ManualScrollToTop from './component/ManualScrollToTop';
import Footer from './component/Footer';
import {BrowserRouter, Routes,Route} from "react-router-dom"
import Header2 from './component/Header2';
import ContactForm from './component/ContactUs';
import ScrollToTop from './component/ScrollToTop';
import CoverLetter from './component/PDFViewer';
// import LinkedInIcon from './Images/circle-linkedin-512.webp'
// import CoverLetterImg from './Images/coverLetterImg.png';
// import CoverLetterPDF from './Images/CHINEDU JOSEPH NDU COVER LETTER 2023.pdf';
// import p1 from './Images/p1.png';
import PastProjects from './component/PastProjects';
import SideIcons from './component/SideIcons';
import PDFViewer from './component/PDFViewer';
// import Credentials from './Images/Credentials_Chinedu Joseph Ndu .pdf'
// import p2 from './Images/p2.png'


const App = () => {

// Determine the main URL dynamically
const mainUrl = window.location.origin;


 
  return (
    <BrowserRouter>
    <ScrollToTop/>
    <Header2/>
      <Routes>
        <Route path="/" element={<LandingPage/>}/>
        <Route path='/contactus' element={<ContactForm/>}/>
        <Route path='/filedisplay/:id' element={<PDFViewer/>}/>
        <Route path='/pastprojects' element={<PastProjects/>}/>

      </Routes>

      <SideIcons/>
      <Footer/>
    </BrowserRouter>
  
   
  )
}

export default App
